export default __webpack_public_path__ + "assets/img/advanceApplication.48f31a4c1eef3f96bab8845c1e419860.png";